(function () {
  'use strict';

  function updateResponsivePdpBGBanner() {
    const screenWidth = window.innerWidth;
    const pdpBGBannerHeading = document.querySelector('.Pdp-Banner-Text-Wrapper h2');
    const pdpBGBannerSubtext = document.querySelector('.Pdp-Banner-Text-Wrapper p');

    if (!pdpBGBannerHeading || !pdpBGBannerSubtext) return;

    // ...............
    // MOBILE.........
    // ...............

    if (screenWidth >= 320 && screenWidth <= 767) {
      pdpBGBannerHeading.classList.remove('text-headline-l-uppercase-desktop');
      pdpBGBannerHeading.classList.remove('text-headline-l-uppercase-mobile');
      pdpBGBannerHeading.classList.add('text-headline-m-uppercase-mobile');

      pdpBGBannerSubtext.classList.remove('text-body-l');
      pdpBGBannerSubtext.classList.add('text-body-s');
    }

    // ................
    // TABLET..........
    // ................

    if (screenWidth >= 768 && screenWidth <= 1023) {
      pdpBGBannerHeading.classList.remove('text-headline-l-uppercase-desktop');
      pdpBGBannerHeading.classList.remove('text-headline-m-uppercase-mobile');
      pdpBGBannerHeading.classList.add('text-headline-l-uppercase-mobile');

      pdpBGBannerSubtext.classList.remove('text-body-s');
      pdpBGBannerSubtext.classList.add('text-body-l');
    }

    // ................
    // LAPTOP..........
    // ................

    if (screenWidth >= 1024 && screenWidth <= 1439) {
      pdpBGBannerHeading.classList.remove('text-headline-m-uppercase-mobile');
      pdpBGBannerHeading.classList.remove('text-headline-l-uppercase-mobile');
      pdpBGBannerHeading.classList.add('text-headline-l-uppercase-desktop');

      pdpBGBannerSubtext.classList.remove('text-body-s');
      pdpBGBannerSubtext.classList.add('text-body-l');
    }

    // ...............
    // DESKTOP........
    // ...............

    if (screenWidth >= 1440) {
      pdpBGBannerHeading.classList.remove('text-headline-m-uppercase-mobile');
      pdpBGBannerHeading.classList.remove('text-headline-l-uppercase-mobile');
      pdpBGBannerHeading.classList.add('text-headline-l-uppercase-desktop');

      pdpBGBannerSubtext.classList.remove('text-body-s');
      pdpBGBannerSubtext.classList.add('text-body-l');
    }
  }

  updateResponsivePdpBGBanner();
  window.addEventListener('resize', updateResponsivePdpBGBanner);
})();
